export const DEFAULT_APP_NAME = 'FluxMind';

export function resolveAppName(value?: string | null) {
  const normalized = (value || '').trim();
  return normalized || DEFAULT_APP_NAME;
}
